// Tiny persisted in-memory database for the mock API (localStorage-backed so bookings survive reloads).
import * as seed from './data';
import { todayKey } from '../../utils/date';

const KEY = 'cp.mockdb.v2';

const fresh = () => ({
  seededOn: todayKey(),
  users: JSON.parse(JSON.stringify(seed.users)),
  appointments: JSON.parse(JSON.stringify(seed.appointments)),
  notifications: JSON.parse(JSON.stringify(seed.notifications)),
  sequence: 100,
});

const load = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return fresh();
    const parsed = JSON.parse(raw);
    // Re-seed each day so the relative demo dates stay sensible.
    return parsed.seededOn === todayKey() ? parsed : fresh();
  } catch (e) {
    return fresh();
  }
};

let state = load();

export const db = {
  get state() {
    return state;
  },
  save() {
    try {
      localStorage.setItem(KEY, JSON.stringify(state));
    } catch (e) {
      /* storage unavailable — keep in memory */
    }
  },
  nextId(prefix) {
    state.sequence += 1;
    return `${prefix}${state.sequence}`;
  },
  reset() {
    state = fresh();
    this.save();
  },
};

export const clinic = seed.clinic;
export const landing = seed.landing;
export const doctors = seed.doctors;
export const MOCK_OTP = seed.MOCK_OTP;
